import { StationsInputMui } from '@app/components/stations/StationsInputMui';
import { useAppData } from '@app/core/app-data';
import { useToast } from '@app/core/notifications';
import { useOwnedStations } from '@app/core/stations/hooks/useOwnedStations';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../api';
import { DescriptionFootersFormContent } from './description-footers/components/DescriptionFootersFormContent';
import { getSchema } from './description-footers/types';

/** Station-scoped form to manage description footers (RHF + MUI). */
export function DescriptionFootersForm() {
  const { refetchStations } = useAppData();
  const stations = useOwnedStations();
  const [station, setStation] = useState(stations[0]);
  const { $t } = useIntl();
  const { notifySuccess } = useToast();
  const schema = useMemo(() => getSchema((msg) => $t(msg)), [$t]);

  const descriptionFooters = station.featuresConfig?.fragments?.descriptionFooters || [];

  return (
    <Box>
      <Box mb={3} maxWidth={400}>
        <StationsInputMui
          stations={stations}
          value={station}
          onChange={setStation}
          selectProps={{
            size: 'small',
          }}
        />
      </Box>

      <FormContainer
        key={station.id}
        defaultValues={{
          descriptionFooters,
        }}
        resolver={zodResolver(schema)}
        onSuccess={async (data) => {
          await apiClient.fragments.configUpdate(station.id, {
            descriptionFooters: data.descriptionFooters,
          });

          notifySuccess(
            $t(
              {
                id: 'admin.fragments.fragmentsConfigUpdated',
                defaultMessage: 'Configuración de fragmentos para {stationName} actualizada',
              },
              { stationName: station.name },
            ),
          );

          refetchStations();
        }}
      >
        <DescriptionFootersFormContent />
      </FormContainer>
    </Box>
  );
}
